@if (!isLoginClient) {
  <app-header></app-header>
}
@if (isLoginClient) {
  <app-header-client></app-header-client>
}
<ngx-spinner bdColor="rgba(102, 102, 102, 0.8)" type="ball-spin-clockwise" template="<img class='spinnerImage' src='assets/img/generic_user_black.png' />" [fullScreen]="true">
  <p class="spinnerText">{{ 'common.loading' | translate }}</p>
</ngx-spinner>

<app-sidebar [class]="getTheme()" (filterEmitter)="updateUnreadNotifications($event)"></app-sidebar>
